var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMobile)?_c('v-btn',{staticClass:"mobile-create-button",attrs:{"fab":"","large":"","color":"primary"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("mdi-plus")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }